import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

require("../../node_modules/van11y-accessible-modal-window-aria/src/van11y-accessible-modal-window-aria.es6");

am4core.addLicense("CH250841442");

const createColor = (value) => {
	let hexColor;
	switch (value) {
		case "primary-blue":
			hexColor = "#00416b";
			break;
		case "primary-sky":
			hexColor = "#00a7e1";
			break;
		case "primary-cyan":
			hexColor = "#54c8e8";
			break;
		case "primary-green":
			hexColor = "#00a98f";
			break;
		case "primary-blue-green":
			hexColor = "#00a19b";
			break;
		case "primary-sea-green":
			hexColor = "#74e0c1";
			break;
		case "primary-yellow":
			hexColor = "#ffda00";
			break;
		case "tint-sky":
			hexColor = "#99DCF3";
			break;
		case "tint-cyan":
			hexColor = "#D5EEF6";
			break;
		case "tint-green":
			hexColor = "#CCEEE9";
			break;
		case "tint-blue-green":
			hexColor = "#66c7c3";
			break;
		case "tint-yellow":
			hexColor = "#fff1af";
			break;
		case "shade-blue":
			hexColor = "#011a28";
			break;
		case "shade-sky":
			hexColor = "#0075a9";
			break;
		case "shade-blue-green":
			hexColor = "#007167";
			break;
		case "shade-yellow":
			hexColor = "#fff1af";
			break;
		case "neutral-1":
			hexColor = "#ebe9e3";
			break;
		case "neutral-2":
			hexColor = "#ccc9ba";
			break;
		case "neutral-3":
			hexColor = "#99978b";
			break;
		case "primary-purple":
			hexColor = "#8a0e72";
			break;
		case "primary-orange":
			hexColor = "#e6762e";
			break;
		case "primary-rose":
			hexColor = "#b32654";
			break;
		case "tint-orange":
			hexColor = "#f0ad82";
			break;
		case "tint-rose":
			hexColor = "#e0a8bb";
			break;
		case "shade-purple":
			hexColor = "#4a0746";
			break;
		case "shade-rose":
			hexColor = "#861d3f";
			break;
		case "black":
			hexColor = "#000";
			break;
		case "near-black":
			hexColor = "#333";
			break;
		case "white":
			hexColor = "#fff";
			break;
		case "transparent":
			hexColor = "#00FFFFFF";
			break;
		default:
			hexColor = "#00416b";
			break;
	}

	return am4core.color(hexColor);
};

const currencyFormatter = new Intl.NumberFormat("en-US", {
	style: "currency",
	currency: "USD",
	minimumFractionDigits: 2
});

function am4themes_ibrTheme(target) {
	if (target instanceof am4core.ColorSet) {
		target.list = [
			createColor("primary-blue"),
			createColor("primary-green"),
			createColor("primary-yellow"),
			createColor("primary-sky"),
			createColor("primary-blue-green"),
			createColor("primary-sea-green"),
			createColor("primary-purple"),
			createColor("primary-orange"),
			createColor("primary-rose"),
			createColor("tint-sky"),
			createColor("tint-cyan"),
			createColor("tint-green"),
			createColor("tint-blue-green"),
			createColor("tint-yellow"),
			createColor("tint-orange"),
			createColor("tint-rose"),
			createColor("shade-blue"),
			createColor("shade-sky"),
			createColor("shade-blue-green"),
			createColor("shade-yellow"),
			createColor("shade-purple"),
			createColor("shade-rose"),
			createColor("neutral-1"),
			createColor("neutral-2"),
			createColor("neutral-3"),
			createColor("black"),
			createColor("near-black"),
			createColor("white"),
			createColor("transparent")
		];
	}
	if (target instanceof am4core.InterfaceColorSet) {
		target.setFor("text", am4core.color("#333"));
		target.setFor("primaryButton", createColor("primary-green"));
	}
}

window.chartData = [];

document.addEventListener("DOMContentLoaded", function () {
	am4core.useTheme(am4themes_ibrTheme);
	am4core.useTheme(am4themes_animated);
	if (window.chartData.length > 1) {
		am4core.options.onlyShowOnViewport = true;
	}

	// Pie charts
	const pieChartData = window.chartData.filter((data) => {
		return data.ChartType == "pie";
	});
	pieChartData.map(function (chart) {
		createPieChart(chart);
	});

	// Stacked Bar charts
	const stackedBarChartData = window.chartData.filter((data) => {
		return data.ChartType === "stackedbar";
	});
	stackedBarChartData.map(function (chart) {
		createStackedBarChart(chart);
	});

	// Bar charts
	const barChartData = window.chartData.filter((data) => {
		return data.ChartType === "bar";
	});
	barChartData.map(function (chart) {
		createBarChart(chart);
	});

	// Gauge charts
	const gaugeChartData = window.chartData.filter((data) => {
		return data.ChartType === "gauge";
	});
	gaugeChartData.map(function (chart) {
		createGaugeChart(chart);
	});

	// Chart Guy
	const chartGuyData = window.chartData.filter((data) => {
		return data.ChartType === "chartguy";
	});
	chartGuyData.map(function (chart) {
		createChartGuy(chart);
	});

	// Budget chart
	const budgetChartData = window.chartData.filter((data) => {
		return data.ChartType === "budget";
	});
	budgetChartData.map(function (chart) {
		createBudgetChart(chart);
	});

	// DBE Budget chart
	const dbeBudgetChartData = window.chartData.filter((data) => {
		return data.ChartType === "dbebudget";
	});
	dbeBudgetChartData.map(function (chart) {
		createDbeBudgetChart(chart);
	});

	// Gantt chart
	const ganttChartData = window.chartData.filter((data) => {
		return data.ChartType === "gantt";
	});
	ganttChartData.map(function (chart) {
		createGanttChart(chart);
	});
});

const createPieChart = (node) => {
	let chart = am4core.create(`${node.ChartDataID}`, am4charts.PieChart);

	// Chart style
	chart.fontFamily = `"source-sans-pro", sans-serif`;
	chart.fontSize = 12;
	chart.tooltipContainer.fontSize = 14;
	chart.tooltip.getFillFromObject = false;
	chart.responsive.enabled = true;

	chart.legend = new am4charts.Legend();
	chart.legend.position = "bottom";
	chart.legend.disabled = true;
	chart.legend.itemContainers.template.paddingTop = 0;
	chart.legend.itemContainers.template.paddingBottom = 0;
	chart.legend.markers.template.width = 12;
	chart.legend.markers.template.height = 12;
	chart.legend.valueLabels.template.align = "right";
	chart.legend.valueLabels.template.textAlign = "start"; 
	chart.legend.valueLabels.template.text = "[bold]{PreLabel}{value.value}{Label}"; 
	let marker = chart.legend.markers.template.children.getIndex(0);
	marker.width = 12
	marker.height = 12

	// Add data
	chart.data = node.Data;

	// Add and configure Series
	let pieSeries = chart.series.push(new am4charts.PieSeries());
	pieSeries.dataFields.value = "Value1";
	pieSeries.dataFields.category = "Name";
	pieSeries.dataFields.currency = "Label";
	pieSeries.fontSize = 14;
	pieSeries.labels.template.wrap = true;
	pieSeries.labels.template.text = "{category}\n[bold]{PreLabel}{value.value}{Label}";
	pieSeries.slices.template.tooltipText = "{category} [bold]{PreLabel}{value.value}{Label}";
	pieSeries.slices.template.stroke = am4core.color("#f4f4f5");
	pieSeries.slices.template.strokeWidth = 2;
	pieSeries.slices.template.strokeOpacity = 1;

	chart.responsive.rules.push({
		relevant: function(target) {
			if (target.pixelWidth <= 400) {
				return true;
			}
			return false;
		},
		state: function(target, stateId) {
			if (target instanceof am4charts.PieSeries) {
				var state = target.states.create(stateId);

				var labelState = target.labels.template.states.create(stateId);
				labelState.properties.disabled = true;

				var tickState = target.ticks.template.states.create(stateId);
				tickState.properties.disabled = true;

				return state;
			}
			if (target instanceof am4charts.Legend) {
				const state = target.states.create(stateId);
				state.properties.disabled = false;

				return state;
			}

			return null;
		}
	});
	chart.responsive.rules.push({
		relevant: function(target) {
			if (target.pixelWidth > 400 && target.pixelWidth < 540) {
				return true;
			}
			return false;
		},
		state: function(target, stateId) {
			if (target instanceof am4charts.PieChart) {
				var state = target.states.create(stateId);
				state.properties.radius = am4core.percent(50)
				return state;
			}
			return null;
		}
	});
	chart.responsive.rules.push({
		relevant: function(target) {
			if (target.pixelWidth > 400) {
				return true;
			}
			return false;
		},
		state: function(target, stateId) {
			if (target instanceof am4charts.PieSeries) {
				var state = target.states.create(stateId);

				var labelState = target.labels.template.states.create(stateId);
				labelState.properties.disabled = false;

				var tickState = target.ticks.template.states.create(stateId);
				tickState.properties.disabled = false;

				return state;
			}
			
			if (target instanceof am4charts.Legend) {
				const state = target.states.create(stateId);
				state.properties.disabled = true;

				return state;
			}


			return null;
		}
	});
};

const createGanttChart = (node) => {
	let chart = am4core.create(`${node.ChartDataID}`, am4charts.XYChart);

	let chartData = [];
	node.Data.map((data) => {
		const hexColor = createColor(data.Color);
		data.Color = hexColor;
		chartData.push(data);
	});

	// Chart style
	chart.fontFamily = `"source-sans-pro", sans-serif`;
	chart.fontSize = 12;
	chart.tooltipContainer.fontSize = 14;
	chart.focusable = true;
	chart.tooltip.getFillFromObject = false;
	chart.responsive.enabled = true;

	// Add data
	chart.data = chartData;

	// Add and configure Series
	chart.dateFormatter.dateFormat = "MM/dd/yyyy";
	chart.dateFormatter.inputDateFormat = "M/d/yyyy hh:mm:ss";

	var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
	categoryAxis.dataFields.category = "Name";
	categoryAxis.renderer.grid.template.location = 0;
	categoryAxis.renderer.inversed = true;
	categoryAxis.fontSize = 14;

	var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
	dateAxis.renderer.minGridDistance = 70;
	dateAxis.baseInterval = { count: 1, timeUnit: "month" };
	dateAxis.groupIntervals.setAll([
		{ timeUnit: "month", count: 1 },
		{ timeUnit: "year", count: 1 }
	]);
	dateAxis.dateFormats.setKey("month", "");
	dateAxis.periodChangeDateFormats.setKey("month", "[bold]yyyy");
	dateAxis.fontSize = 14;

	dateAxis.renderer.tooltipLocation = 0;

	var series1 = chart.series.push(new am4charts.ColumnSeries());
	series1.columns.template.height = am4core.percent(70);
	series1.columns.template.tooltipText = "{Name} [bold]{Value1Text}[/] - [bold]{Value2Text}[/]";
	series1.fontSize = 14;

	series1.dataFields.openDateX = "Value1";
	series1.dataFields.dateX = "Value2";
	series1.dataFields.categoryY = "Name";
	series1.columns.template.propertyFields.fill = "Color"; // get color from data
	series1.columns.template.propertyFields.stroke = "Color";
	series1.columns.template.strokeOpacity = 1;
};

const createBudgetChart = (node) => {
	let chart = am4core.create(`${node.ChartDataID}`, am4charts.PieChart);

	// Chart style
	chart.fontFamily = `"source-sans-pro", sans-serif`;
	chart.fontSize = 12;
	chart.tooltipContainer.fontSize = 14;
	chart.innerRadius = am4core.percent(40);
	chart.padding = 0;
	chart.focusable = true;
	chart.tooltip.getFillFromObject = false;
	chart.responsive.enabled = true;

	// Add and configure Series
	var contractedSeries1 = chart.series.push(new am4charts.PieSeries());
	contractedSeries1.dataFields.value = "value";
	contractedSeries1.dataFields.category = "category";
	contractedSeries1.slices.template.states.getKey("hover").properties.shiftRadius = 0;
	contractedSeries1.slices.template.states.getKey("hover").properties.scale = 1;
	contractedSeries1.slices.template.fill = am4core.color("#d0d3d2");

	contractedSeries1.slices.template.propertyFields.disabled = "labelDisabled";
	contractedSeries1.labels.template.propertyFields.disabled = "labelDisabled";
	contractedSeries1.ticks.template.propertyFields.disabled = "labelDisabled";

	contractedSeries1.slices.template.stroke = am4core.color("#fff");
	contractedSeries1.slices.template.strokeWidth = 2;
	contractedSeries1.slices.template.strokeOpacity = 1;

	// Add data
	contractedSeries1.data = [
		{
			category: "Contracted",
			value: node.Contracted
		},
		{
			category: "Contracted Remaining",
			value: 100,
			labelDisabled: true
		}
	];

	// Disable sliding out of slices
	contractedSeries1.slices.template.states.getKey("hover").properties.shiftRadius = 0;
	contractedSeries1.slices.template.states.getKey("hover").properties.scale = 1;

	var contractedSeries2 = chart.series.push(new am4charts.PieSeries());
	contractedSeries2.dataFields.value = "value";
	contractedSeries2.dataFields.category = "category";
	contractedSeries2.slices.template.states.getKey("hover").properties.shiftRadius = 0;
	contractedSeries2.slices.template.states.getKey("hover").properties.scale = 1;
	contractedSeries2.slices.template.fill = am4core.color("#d0d3d2");

	contractedSeries2.slices.template.propertyFields.disabled = "labelDisabled";
	contractedSeries2.labels.template.propertyFields.disabled = "labelDisabled";
	contractedSeries2.ticks.template.propertyFields.disabled = "labelDisabled";

	contractedSeries2.slices.template.stroke = am4core.color("#fff");
	contractedSeries2.slices.template.strokeWidth = 2;
	contractedSeries2.slices.template.strokeOpacity = 1;

	// Add data
	contractedSeries2.data = [
		{
			category: "Contracted",
			value: node.Contracted
		},
		{
			category: "Contracted Remaining",
			value: 100,
			labelDisabled: true
		}
	];

	// Disable sliding out of slices
	contractedSeries2.slices.template.states.getKey("hover").properties.shiftRadius = 0;
	contractedSeries2.slices.template.states.getKey("hover").properties.scale = 1;

	// Add second series
	var pieSeries2 = chart.series.push(new am4charts.PieSeries());
	pieSeries2.dataFields.value = "value";
	pieSeries2.dataFields.category = "category";
	pieSeries2.slices.template.states.getKey("hover").properties.shiftRadius = 0;
	pieSeries2.slices.template.states.getKey("hover").properties.scale = 1;

	pieSeries2.slices.template.propertyFields.disabled = "labelDisabled";
	pieSeries2.labels.template.propertyFields.disabled = "labelDisabled";
	pieSeries2.ticks.template.propertyFields.disabled = "labelDisabled";

	pieSeries2.slices.template.stroke = am4core.color("#fff");
	pieSeries2.slices.template.strokeWidth = 2;
	pieSeries2.slices.template.strokeOpacity = 1;

	// Add data
	pieSeries2.data = [
		{
			category: "Authorized Budget",
			value: node.AuthorizedBudget
		},
		{
			category: "Authorized Budget Remaining",
			value: node.Contracted - node.AuthorizedBudget,
			labelDisabled: true
		}
	];

	// Add third series
	var expendituresSeries = chart.series.push(new am4charts.PieSeries());
	expendituresSeries.dataFields.value = "value";
	expendituresSeries.dataFields.category = "category";
	expendituresSeries.slices.template.states.getKey("hover").properties.shiftRadius = 0;
	expendituresSeries.slices.template.states.getKey("hover").properties.scale = 1;
	expendituresSeries.slices.template.fill = createColor("primary-green");

	expendituresSeries.slices.template.propertyFields.disabled = "labelDisabled";
	expendituresSeries.labels.template.propertyFields.disabled = "labelDisabled";
	expendituresSeries.ticks.template.propertyFields.disabled = "labelDisabled";

	expendituresSeries.slices.template.stroke = am4core.color("#fff");
	expendituresSeries.slices.template.strokeWidth = 2;
	expendituresSeries.slices.template.strokeOpacity = 1;

	// Add data
	expendituresSeries.data = [
		{
			category: "Expenditures",
			value: node.Expenditures
		},
		{
			category: "Remaining",
			value: node.Contracted - node.Expenditures,
			labelDisabled: true
		}
	];

	contractedSeries1.adapter.add("innerRadius", function (innerRadius, target) {
		return am4core.percent(0);
	});

	contractedSeries2.adapter.add("innerRadius", function (innerRadius, target) {
		return am4core.percent(50);
	});

	pieSeries2.adapter.add("innerRadius", function (innerRadius, target) {
		return am4core.percent(0);
	});

	expendituresSeries.adapter.add("innerRadius", function (innerRadius, target) {
		return am4core.percent(50);
	});

	contractedSeries1.adapter.add("radius", function (innerRadius, target) {
		return am4core.percent(50);
	});
	contractedSeries2.adapter.add("radius", function (innerRadius, target) {
		return am4core.percent(100);
	});

	pieSeries2.adapter.add("radius", function (innerRadius, target) {
		return am4core.percent(50);
	});

	expendituresSeries.adapter.add("radius", function (innerRadius, target) {
		return am4core.percent(100);
	});

	contractedSeries1.labels.template.disabled = true;
	contractedSeries1.slices.template.tooltipText = "{category} [bold]${value.value}[/]";

	contractedSeries2.labels.template.disabled = true;
	contractedSeries2.slices.template.tooltipText = "{category} [bold]${value.value}[/]";

	pieSeries2.labels.template.disabled = true;
	pieSeries2.slices.template.tooltipText = "{category} [bold]${value.value}[/]";

	expendituresSeries.labels.template.disabled = true;
	expendituresSeries.slices.template.tooltipText = "{category} [bold]${value.value}[/]";

	var legend = new am4charts.Legend();
	legend.parent = chart.chartAndLegendContainer;
	legend.marginTop = 24;
	legend.data = [
		{
			name: "Authorized Budget\n[bold]" + currencyFormatter.format(node.AuthorizedBudget),
			fill: am4core.color("#00416b")
		},
		{
			name: "Expenditures\n[bold]" + currencyFormatter.format(node.Expenditures),
			fill: am4core.color("#00a98f")
		},
		{
			name: "Contracted\n[bold]" + currencyFormatter.format(node.Contracted),
			fill: am4core.color("#d0d3d2")
		}
	];
	legend.itemContainers.template.togglable = false;
	legend.itemContainers.template.clickable = false;
	legend.itemContainers.template.focusable = false;
	legend.itemContainers.template.cursorOverStyle = am4core.MouseCursorStyle.default;
	legend.fontSize = 16;

	let valueText = chart.chartContainer.createChild(am4core.Label);
	valueText.text = `Program Budget\n[bold]${currencyFormatter.format(node.ProgramBudget)}`;
	valueText.x = am4core.percent(50);
	valueText.y = am4core.percent(100);
	valueText.textAlign = "middle";
	valueText.horizontalCenter = "middle";
	valueText.verticalCenter = "top";
	valueText.baseLineRatio = -1;
};

const createDbeBudgetChart = (node) => {
	let chart = am4core.create(`${node.ChartDataID}`, am4charts.XYChart);

	// Chart style
	chart.fontFamily = `"source-sans-pro", sans-serif`;
	chart.fontSize = 12;
	chart.tooltipContainer.fontSize = 14;
	chart.padding = 0;
	chart.focusable = true;
	chart.responsive.enabled = true;

	var data = [
		{
			category: "Sept 2020 - June 2021",
			totalValue: 100,
			totalAmount: node.TotalBudget,
			targetValue: node.DbeTarget,
			actualValue: node.DbeActual,
			actualAmount: currencyFormatter.format(node.Expenditures)
		}
	];

	chart.data = data;

	var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
	categoryAxis.dataFields.category = "category";
	categoryAxis.renderer.grid.template.strokeOpacity = 0;
	categoryAxis.renderer.labels.template.disabled = true;
	categoryAxis.fontSize = 14;

	var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
	valueAxis.min = 0;
	valueAxis.max = 100;
	valueAxis.strictMinMax = true;
	valueAxis.fontSize = 14;

	// axis break
	var axisBreak = valueAxis.axisBreaks.create();
	axisBreak.startValue = 35;
	axisBreak.endValue = 85;
	axisBreak.breakSize = 0.001;
	axisBreak.opacity = 0.3;

	var columnSeries = chart.series.push(new am4charts.ColumnSeries());
	columnSeries.name = "Actual";
	columnSeries.dataFields.valueY = "actualValue";
	columnSeries.dataFields.categoryX = "category";
	columnSeries.itemReaderText = "Target participation {targetValue}%, Actual participation {valueY}% of {actualAmount}";
	columnSeries.columns.template.tooltipText = "Target [bold]{targetValue}%[/]\n{name} [bold]{valueY}%\n[regular]{actualAmount}";
	columnSeries.fill = createColor("primary-yellow");
	columnSeries.stroke = createColor("primary-yellow");

	var stepSeries = chart.series.push(new am4charts.StepLineSeries());
	stepSeries.name = "Target";
	stepSeries.dataFields.valueY = "targetValue";
	stepSeries.dataFields.categoryX = "category";

	stepSeries.stroke = createColor("primary-blue");
	stepSeries.strokeWidth = 2;
	stepSeries.strokeDasharray = "3,3";
	stepSeries.startLocation = 0;
	stepSeries.endLocation = 1;
};

const createStackedBarChart = (node) => {
	let chart = am4core.create(`${node.ChartDataID}`, am4charts.XYChart);

	var categoryAxis, valueAxis;
	if (node.Direction == "vertical") {
		categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
		valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
	} else {
		categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
		valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
	}

	// Chart style
	chart.fontFamily = `"source-sans-pro", sans-serif`;
	chart.fontSize = 14;
	chart.tooltipContainer.fontSize = 14;
	chart.focusable = true;
	chart.tooltip.getFillFromObject = false;
	chart.tooltip.background.fill = am4core.color("#333");
	chart.responsive.enabled = true;
	chart.paddingRight = 36;
	chart.legend = new am4charts.Legend();
	chart.legend.itemContainers.template.clickable = false;
	chart.legend.itemContainers.template.focusable = false;
	chart.legend.itemContainers.template.cursorOverStyle = am4core.MouseCursorStyle.default;
	chart.legend.fontSize = 12;

	chart.legend.itemContainers.template.paddingTop = 0;
	chart.legend.itemContainers.template.paddingBottom = 0;
	chart.legend.markers.template.width = 12;
	chart.legend.markers.template.height = 12;
	chart.legend.valueLabels.template.align = "right";
	chart.legend.valueLabels.template.textAlign = "start"; 
	chart.legend.valueLabels.template.text = "[bold]{PreLabel}{value.value}{Label}"; 
	let marker = chart.legend.markers.template.children.getIndex(0);
	marker.width = 12
	marker.height = 12

	// Add data
	chart.data = node.Data;

	// Create axes
	categoryAxis.dataFields.category = "Name";
	categoryAxis.title.disabled = true;
	categoryAxis.renderer.grid.template.location = 0;
	categoryAxis.renderer.minGridDistance = 10;
	categoryAxis.fontSize = 14;

	valueAxis.title.disabled = true;

	if (node.DisplayName == "Contracted Budget by Category") {
		valueAxis.min = 0;
		valueAxis.max = 21382963;
		valueAxis.strictMinMax = true;
		valueAxis.fontSize = 14;

		// axis break
		var axisBreak = valueAxis.axisBreaks.create();
		axisBreak.startValue = 12000000;
		axisBreak.endValue = 20000000;
		axisBreak.breakSize = 0.05;
		axisBreak.opacity = 0.8;

		// make break expand on hover
		var hoverState = axisBreak.states.create("hover");
		hoverState.properties.breakSize = 1;
		hoverState.properties.opacity = 0.1;
		hoverState.transitionDuration = 1500;

		axisBreak.defaultState.transitionDuration = 1000;
	}

	// Create series
	var series = chart.series.push(new am4charts.ColumnSeries());
	if (node.Direction == "vertical") {
		series.dataFields.valueY = "Value1";
		series.dataFields.categoryX = "Name";
		series.tooltipText = "{name} [bold]{valueY} {Label}[/]";
	} else {
		series.dataFields.valueX = "Value1";
		series.dataFields.categoryY = "Name";
		series.tooltipText = "{name} [bold]{valueX} {Label}[/]";
	}
	series.name = node.Value1Label;
	series.stacked = true;
	series.sequencedInterpolation = true;
	series.dy = -3;
	series.columns.template.background.adapter.add("fill", function (fill, target) {
		//if (target.dataItem.dataContext.hasOwnProperty('Color')) {
		//	return createColor(target.dataItem.dataContext.Color);
		//} else {
		return createColor("primary-blue");
		//	}
	});
	series.strokeWidth = 0;

	var series1 = chart.series.push(new am4charts.ColumnSeries());
	if (node.Direction == "vertical") {
		series1.dataFields.valueY = "Value2";
		series1.dataFields.categoryX = "Name";
		series1.tooltipText = "{name} [bold]{valueY} {Label}[/]";
	} else {
		series1.dataFields.valueX = "Value2";
		series1.dataFields.categoryY = "Name";
		series1.tooltipText = "{name} [bold]{valueX} {Label}[/]";
	}
	series1.sequencedInterpolation = true;
	series1.dy = 3;
	series1.name = node.Value2Label;

	series1.columns.template.adapter.add("fill", function (fill, target) {
		var pattern = new am4core.LinePattern();
		pattern.width = 10;
		pattern.height = 10;
		pattern.strokeWidth = 1;
		pattern.stroke = am4core.color("#fff");
		pattern.strokeOpacity = 0.5;
		pattern.rotation = 45;
		return pattern;
	});
	series1.columns.template.background.adapter.add("fill", function (fill, target) {
		//if (target.dataItem.dataContext.hasOwnProperty('Color')) {
		//	return createColor(target.dataItem.dataContext.Color);
		//} else {
		return createColor("primary-green");
		//	}
	});
	series1.strokeWidth = 0;

	series1.tooltip.getFillFromObject = false;
	series1.tooltip.background.fill = createColor("primary-green");

	chart.legend.markers.template.background.adapter.add("fillOpacity", function (fill, target) {
		return 1;
	});
	chart.legend.markers.template.background.adapter.add("fill", function (fill, target) {
		return createColor("primary-green");
	});

	// Add cursor
	chart.cursor = new am4charts.XYCursor();

	
	chart.responsive.rules.push({
		relevant: function(target) {
			if (target.pixelWidth <= 540) {
				return true;
			}
			return false;
		},
		state: function(target, stateId) {
			if (target instanceof am4charts.XYChart) {
				var state = target.states.create(stateId);
				//state.properties.fontSize = 12
				return state;
			}
			if (target instanceof am4charts.CategoryAxis) {
				var state = target.states.create(stateId);
				state.properties.fontSize = 12
				return state;
			}
			if (target instanceof am4charts.ValueAxis) {
				var state = target.states.create(stateId);
				state.properties.fontSize = 12
				return state;
			}

			return null;
		}
	});
};

const createBarChart = (node) => {
	let chart = am4core.create(`${node.ChartDataID}`, am4charts.XYChart);

	// Chart style
	chart.fontFamily = `"source-sans-pro", sans-serif`;
	chart.fontSize = 14;
	chart.tooltipContainer.fontSize = 14;
	chart.focusable = true;
	chart.tooltip.getFillFromObject = false;
	chart.responsive.enabled = true;
	chart.legend = new am4charts.Legend();
	chart.legend.itemContainers.template.clickable = false;
	chart.legend.itemContainers.template.focusable = false;
	chart.legend.itemContainers.template.cursorOverStyle = am4core.MouseCursorStyle.default;
	if (node.Value1Color != null) {
		chart.legend.fill = createColor(node.Value1Color);
	} else {
		chart.legend.fill = createColor("primary-blue");
	}
	chart.legend.fontSize = 12;
	if (node.Orientation == "horizontal") chart.paddingRight = 35;

	chart.legend.itemContainers.template.paddingTop = 0;
	chart.legend.itemContainers.template.paddingBottom = 0;
	chart.legend.markers.template.width = 12;
	chart.legend.markers.template.height = 12;
	chart.legend.valueLabels.template.align = "right";
	chart.legend.valueLabels.template.textAlign = "start"; 
	chart.legend.valueLabels.template.text = "[bold]{PreLabel}{value.value}{Label}"; 
	let marker = chart.legend.markers.template.children.getIndex(0);
	marker.width = 12
	marker.height = 12


	// Add data
	chart.data = node.Data;

	var categoryAxis, valueAxis;
	if (node.Orientation == "horizontal") {
		categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
		valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
	} else {
		categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
		valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
	}

	// Set upper and lower bounds for the value axis
	if (node.ValueLowerBounds != null) valueAxis.min = Number(node.ValueLowerBounds); // Set the lower bound
	if (node.ValueUpperBounds != null) valueAxis.max = Number(node.ValueUpperBounds); // Set the upper bound
	if (node.ValueUpperBounds != null || node.ValueLowerBounds != null) valueAxis.strictMinMax = true;

	// Create axes
	categoryAxis.dataFields.category = "Name";
	categoryAxis.title.text = node.CategoryLabel;
	categoryAxis.renderer.grid.template.location = 0;
	categoryAxis.renderer.minGridDistance = 10;
	categoryAxis.fontSize = 14;
	valueAxis.fontSize = 14;
	//columnSpacing = 0;

	// Configure axis label
	var label = categoryAxis.renderer.labels.template;
	label.id = "label";
	label.truncate = true;
	label.wrap = false;
	label.tooltipText = "{category}";
	label.minWidth = 60;

	// categoryAxis.events.on("sizechanged", function (ev) {
	// 	var axis = ev.target;
	// 	var cellWidth = axis.pixelWidth / (axis.endIndex - axis.startIndex);
	// 	axis.renderer.labels.template.maxWidth = cellWidth;
	// });


	// Create series
	var series = chart.series.push(new am4charts.ColumnSeries());
	if (node.Orientation == "horizontal") {
		series.dataFields.valueX = "Value1";
		series.dataFields.categoryY = "Name";
		series.tooltipText = "{name} [bold]{valueX} {Label}[/]";
	} else {
		series.dataFields.valueY = "Value1";
		series.dataFields.categoryX = "Name";
		series.tooltipText = "{name} [bold]{valueY} {Label}[/]";
	}
	series.columns.template.adapter.add("fill", (fill, target) => {
		if (node.Value1Color != null) {
			return createColor(node.Value1Color);
		} else {
			return createColor("primary-blue");
		}
	});
	series.columns.template.adapter.add("stroke", (fill, target) => {
		if (node.Value1Color != null) {
			return createColor(node.Value1Color);
		} else {
			return createColor("primary-blue");
		}
	});

	series.name = node.Value1Label;

	// Add cursor
	chart.cursor = new am4charts.XYCursor();


	chart.responsive.rules.push({
		relevant: function(target) {
			if (target.pixelWidth <= 540) {
				return true;
			}
			return false;
		},
		state: function(target, stateId) {
			if (target instanceof am4charts.CategoryAxis) {
				var state = target.states.create(stateId);
				state.properties.fontSize = 12
				return state;
			}
			if (target instanceof am4charts.ValueAxis) {
				var state = target.states.create(stateId);
				state.properties.fontSize = 12
				return state;
			}

			return null;
		}
	});

};

const createGaugeChart = (node) => {
	let chart = am4core.create(`${node.ChartDataID}`, am4charts.GaugeChart);

	// Chart style
	chart.fontFamily = `"source-sans-pro", sans-serif`;
	chart.fontSize = 14;
	chart.tooltipContainer.fontSize = 14;
	chart.focusable = true;
	chart.tooltip.getFillFromObject = false;
	chart.responsive.enabled = true;
	chart.innerRadius = -33;

	// Add data
	chart.data = node.Data;

	var axis = chart.xAxes.push(new am4charts.ValueAxis());
	axis.min = node.MinValue;
	axis.max = node.MaxValue;
	axis.fontSize = 14;
	axis.strictMinMax = true;
	if (node.ValuePrefix != "" || node.ValueSuffix != "") {
		axis.numberFormatter = new am4core.NumberFormatter();
		var numberFormat = "";
		if (node.ValuePrefix != "" && node.ValueSuffix != "") numberFormat = `'${node.ValuePrefix}'#'${node.ValueSuffix}'`;
		if (node.ValuePrefix != "") numberFormat = `'${node.ValuePrefix}'#`;
		if (node.ValueSuffix != "") numberFormat = `#'${node.ValueSuffix}'`;
		axis.numberFormatter.numberFormat = numberFormat;
	}

	var range = axis.axisRanges.create();
	range.value = node.MinValue;
	range.endValue = node.MaxValue;
	range.axisFill.fillOpacity = 1;
	range.axisFill.fill = createColor("neutral-1");
	range.axisFill.zIndex = -1;

	var legend = new am4charts.Legend();
	legend.parent = chart.chartAndLegendContainer;
	legend.marginTop = 24;
	legend.itemContainers.template.togglable = false;
	legend.itemContainers.template.clickable = false;
	legend.itemContainers.template.focusable = false;
	legend.markers.template.disabled = true;
	legend.fontSize = 16;

	node.Data.map((data) => {
		var hand = chart.hands.push(new am4charts.ClockHand());
		hand.value = data.Value;
		hand.startWidth = 20;
		if (data.Color != null) {
			hand.fill = createColor(data.Color);
		} else {
			hand.fill = am4core.color("#333");
		}
		hand.stroke = am4core.color("#fff");
		hand.strokeOpacity = 0.33;
		hand.strokeWidth = 1;
		hand.pin.disabled = true;
		hand.innerRadius = 0;
		hand.strokeLineCap = "round";

		if (data.Display == false) {
			hand.hide();
		}

		legend.addData({
			name: data.Name + "\n[bold]" + node.ValuePrefix + data.Value + node.ValueSuffix
		});
	});

	node.Ranges.map((range) => {
		if (range.Color != null) {
			var dataRange = axis.axisRanges.create();
			dataRange.value = range.Value;
			dataRange.endValue = range.EndValue;
			dataRange.axisFill.fillOpacity = 1;
			dataRange.axisFill.fill = createColor(range.Color);
			dataRange.axisFill.zIndex = -1;
		}
	});
};

const createChartGuy = (node) => {
	var iconPath =
		"M53.5,476c0,14,6.833,21,20.5,21s20.5-7,20.5-21V287h21v189c0,14,6.834,21,20.5,21 c13.667,0,20.5-7,20.5-21V154h10v116c0,7.334,2.5,12.667,7.5,16s10.167,3.333,15.5,0s8-8.667,8-16V145c0-13.334-4.5-23.667-13.5-31 s-21.5-11-37.5-11h-82c-15.333,0-27.833,3.333-37.5,10s-14.5,17-14.5,31v133c0,6,2.667,10.333,8,13s10.5,2.667,15.5,0s7.5-7,7.5-13 V154h10V476 M61.5,42.5c0,11.667,4.167,21.667,12.5,30S92.333,85,104,85s21.667-4.167,30-12.5S146.5,54,146.5,42 c0-11.335-4.167-21.168-12.5-29.5C125.667,4.167,115.667,0,104,0S82.333,4.167,74,12.5S61.5,30.833,61.5,42.5z";

	var chart = am4core.create(`${node.ChartDataID}`, am4charts.SlicedChart);

	chart.hiddenState.properties.opacity = 0; // this makes initial fade in effect

	chart.fontFamily = `"source-sans-pro", sans-serif`;
	chart.fontSize = 12;
	chart.tooltipContainer.fontSize = 14;
	chart.focusable = true;
	chart.tooltip.getFillFromObject = false;

	//Add Data
	chart.data = node.Data;

	var series = chart.series.push(new am4charts.PictorialStackedSeries());
	series.dataFields.value = "Value1";
	series.dataFields.category = "Name";
	series.alignLabels = true;

	series.maskSprite.path = iconPath;
	series.ticks.template.locationX = 1;
	series.ticks.template.locationY = 0.5;

	series.labels.template.wrap = true;
	series.labels.template.text = "{category}\n[bold]{value} {label}";
	series.slices.template.tooltipText = "{category} [bold]{value.value} {Label}[/]";
};
